import jQuery from 'jquery';
import fetchOddsTable from './helpers/fetchOddsTable';
import hideNavTab from './helpers/hideNavTab';
import createLsHelper from './helpers/createLsHelper';
import initOdds from '../oddsTabHandler';

const $body = jQuery(document.body);

const svgHtml = `
    <svg class="ui-icon ui-icon_sizeMedium js-odds-row-arrow">
        <use xlink:href="img/icons.svg#icon-down"/>
    </svg>
`;

const rowSelector = id => `.js-RC-runnerRow[data-ugc-runnerid=${id}] .RC-runnerCardWrapper`;

const insertRowToPage = (idx, row) =>
    jQuery(rowSelector(row.dataset.oddsHorseUid)).after(row);

const insertSvg = $rows => $rows.find('.RC-oddsRunner').html(svgHtml).parent();

const tableWrap = $el =>
    $el.wrap('<table class="RC-oddsRunnerContent__wrapTable"></table>').parent();

const variant3 = () => {
    hideNavTab();
    const $btn = jQuery('.js-odds-variant3-btn');
    if (!$btn.length) { return; }

    const lsHelper = createLsHelper('.js-odds-variant3', false);
    $btn.show();
    $body.addClass('odds-var3');

    fetchOddsTable().then((oddsTable) => {
        const $oddsTable = jQuery(oddsTable);
        const $wrapper = jQuery('.js-RC-runnerRowWrapper');

        const $rows = insertSvg($oddsTable.find('.js-diffusionBestOdds'));
        const $header = tableWrap($oddsTable.find('.js-odds-thead'));
        const $footer = tableWrap($oddsTable.find('.js-odds-tfoot'));

        $wrapper.before(tableWrap($header)).after(tableWrap($footer));
        $rows.each(insertRowToPage);

        initOdds();

        $btn.click(() => {
            $body.toggleClass('odds-var3_expanded');
            lsHelper.set($body.hasClass('odds-var3_expanded'));
        });
        $body.on('click', '.js-odds-row-arrow', e =>
            jQuery(e.target).closest('.js-diffusionBestOdds').toggleClass('collapsed')
        );

        if (lsHelper.get()) {
            $btn.trigger('click');
        }
    });
};

export default variant3;



// WEBPACK FOOTER //
// ./lib/js/modules/odds/variant3.js